/**
 *
 *
 * @param {*} date
 * @return {*} zeroing date: string date
*/
const zeroingDate = (date?: string | undefined): number => date
    ? new Date(date).setHours(0, 0, 0, 0)
    : new Date().setHours(0, 0, 0, 0);

/**
 *
 *
 * @param {*} date
 * @return {*} expiration date: number
*/
const getAmountOfExpirationDays = (date: string): number => {
    const dayMilliseconds = 86400000;
    const currentDate = zeroingDate();
    const dateDifference = zeroingDate(date) - currentDate;

    return dateDifference < 0 ? 0 : Math.floor(dateDifference / dayMilliseconds);
};

/**
 *
 *
 * @param {*} { description, name, code }
 * @return {*} { isNew: number, popular: number, hot: number, exclusive:number }
*/
interface ExpirationDays {
    description: string;
    name: string;
    code: string;
}

interface ExpirationDaysResultValue {
    isNew: number;
    popular: number;
    hot: number;
    exclusive: number;
    [key: string]: number;
}

const getExpirationDays = ({
    description, name, code
}: ExpirationDays): ExpirationDaysResultValue => {
    let expirationDatesObject;

    const result: ExpirationDaysResultValue = {
        isNew: 1,
        popular: 1,
        hot: 1,
        exclusive: 1
    };

    if (!description?.includes('expirationDate') || typeof description !== 'string') {
        return result;
    }

    try {
        expirationDatesObject = JSON.parse(description)?.expirationDate;
    } catch (error) {
        console.error(`The structure of your object for (gameName: ${name}, gameCode: ${code}) is not correct, please check!`);
    }

    for (const label in expirationDatesObject) {
        if (Object.prototype.hasOwnProperty.call(expirationDatesObject, label)) {
            result[label] = getAmountOfExpirationDays(expirationDatesObject[label]);
        }
    }

    return result;
};

/**
 *
 *
 * @param {*} { description, name, code, isNew, hot, popular, exclusive }
 * @return {*} { renderNew: boolean renderHot: boolean renderPopular: boolean renderExclusive: boolean }
*/
interface Labels {
    description: string;
    name: string;
    code: string;
    isNew: boolean;
    hot: boolean;
    popular: boolean;
    exclusive: boolean;
}

type Translate = (arg: string) => string

interface LabelsReturnedValue {
    renderNew: string | false;
    renderHot: string | false;
    renderPopular: string | false;
    renderExclusive: string | false;
    renderDefault: string;
}

export const getLabelStatus = ({
    description, name, code, isNew, hot, popular, exclusive
}: Labels, translate: Translate): LabelsReturnedValue => {
    const prefix = 'playtech.mobile.responsivegames.game.label';

    const {
        isNew: expiredNew, popular: expiredPopular, hot: expiredHot, exclusive: expiredExclusive
    } = getExpirationDays({ description, name, code });

    return {
        renderNew: Boolean(isNew && expiredNew) && translate(`${prefix}.new`),
        renderHot: Boolean(hot && expiredHot) && translate(`${prefix}.hot`),
        renderPopular: Boolean(popular && expiredPopular) && translate(`${prefix}.popular`),
        renderExclusive: Boolean(exclusive && expiredExclusive) && translate(`${prefix}.exclusive`),
        renderDefault: translate(`${prefix}.default`)
    };
};

export default {
    getExpirationDays,
    getLabelStatus
};
